function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#999",
  fillRule: "evenodd",
  d: "M14.877 14.143l-3.52-3.52a.324.324 0 00-.232-.096h-.281A5.675 5.675 0 006.676 1C3.541 1 1 3.54 1 6.676a5.675 5.675 0 009.527 4.17v.279c0 .087.036.169.096.232l3.52 3.52a.328.328 0 00.464 0l.27-.27a.328.328 0 000-.464zm-8.2-2.663a4.8 4.8 0 01-4.804-4.804 4.8 4.8 0 014.803-4.803 4.8 4.8 0 014.804 4.803 4.8 4.8 0 01-4.804 4.804z"
});

function SvgSearchinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default SvgSearchinline;